var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLens3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets/Glyphs/Product/Lens Class") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets/Glyphs/Product/Lens-Class",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.000000, 9.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(4.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.135861762,12.0233136 C0.427809293,14.7197875 1.20107465,17.0810011 2.55951125,18.8285203 M5.0191881,20.9385175 C6.27121299,21.622096 7.78216427,22 9.57898291,22 C16.4719626,22 25,10.8766432 25,5.43832159 C25,1.81277386 22.644081,0 17.932243,0 C15.0895639,0 12.5780337,0 10.3976526,0 C7.19905633,0 0.311823439,2.24614254 0.0102380324,8.93513933 C0.00345169905,9.08565643 0,9.23842317 0,9.39346457",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    transform: "translate(8.750000, 19.321068) scale(1, -1) translate(-8.750000, -19.321068) ",
    points: "0 28.0710678 17.5 28.0710678 0 10.5710678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,11 C11.5,12.5466265 12.085188,13.956575 13.0462284,15.0205099",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLens3);
export default __webpack_public_path__ + "static/media/lens3.d5888002ac80db5a8df1d489d715d379.svg";
export { ForwardRef as ReactComponent };